import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from '@headlessui/react';
import isServer from 'commons/isServer';
import { createPortal } from 'react-dom';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import Login from './login';
import SignUp from './signup';
import GiftCard from './GiftCard';
import BagSaved from './BagSaved';
import PasswordReset from './PasswordReset';
import ForgotPassword from './forgotPassword';
import TradeQuotesBanner from './TradeQuotesBanner';
import LivestreamNotification from './LivestreamNotification';
import UserOrdersProtectionPlanBanner from './UserOrdersProtectionPlan';
import UserOrdersSubmitReviewPhotoBanner from './UserOrdersSubmitReviewPhoto';
import FabricFavoritedBanner from './FabricFavoritedBanner';
import notificationBannerHelper, { useForceUpdate } from './utils';
const sidebarModalRootElement = !isServer() ? document.getElementById('SidebarModal-root') : null;
const SlideOut = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <Transition {...props}>{children}</Transition>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
SlideOut.propTypes = {
  children: PropTypes.node,
  modifier: PropTypes.string
};
const NotificationBanner = () => {
  const $ = _c(12);
  notificationBannerHelper.setUpdater(useForceUpdate());
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = notificationBannerHelper.getWelcomeMsgState();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    type,
    props
  } = t0;
  if (isServer()) {
    return null;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SlideOut show={type === "login"}><Login {...props} /></SlideOut>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SlideOut show={type === "signup"}><SignUp {...props} /></SlideOut>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SlideOut show={type === "forgotPassword"}><ForgotPassword {...props} /></SlideOut>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SlideOut show={type === "BagSaved"}><BagSaved {...props} /></SlideOut>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SlideOut show={type === "GiftCard"}><GiftCard {...props} /></SlideOut>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SlideOut show={type === "PasswordReset"}><PasswordReset {...props} /></SlideOut>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SlideOut show={type === "TradeQuotesBanner"}><TradeQuotesBanner {...props} /></SlideOut>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SlideOut show={type === "UserOrdersProtectionPlan"}><UserOrdersProtectionPlanBanner {...props} /></SlideOut>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SlideOut show={type === "UserOrdersSubmitReviewPhoto"}><UserOrdersSubmitReviewPhotoBanner {...props} /></SlideOut>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SlideOut show={type === "LivestreamNotification"}><LivestreamNotification {...props} /></SlideOut>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = createPortal(<>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}<SlideOut show={type === "FabricFavoritedBanner"} modifier="top"><FabricFavoritedBanner {...props} /></SlideOut></>, sidebarModalRootElement);
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
};
export default withBrowserOnly(NotificationBanner);